import { axiosInstanceWebsite } from "../instance";

export const getSubDomain = async (websiteId: string) => {
    const response = await axiosInstanceWebsite.get(`/websites/subdomain/websiteId/${websiteId}`);
    return response.data;
};

export interface WebsitePublicUrlResponse {
    owner_id: string;
    website_id: string;
    subdomain: string;
    primary_domain: string | null;
    primary_host: string;
    primary_public_url: string;
    primary_source: string;
    domain_assignment_status: string | null;
    domain_status: string | null;
    legacy_onlinesl_host: string;
    legacy_onlinesl_url: string;
    legacy_onlinesl_status: string;
}

export const getWebsitePublicUrl = async (
    websiteId: string
): Promise<WebsitePublicUrlResponse> => {
    const response = await axiosInstanceWebsite.get(`/websites/public-url/websiteId/${websiteId}`);
    return response.data;
};

export interface StorePublicUrlResponse {
    owner_id: string;
    store_id: string;
    subdomain: string;
    primary_domain: string | null;
    primary_host: string;
    primary_public_url: string;
    primary_source: string;
    domain_assignment_status: string | null;
    domain_status: string | null;
    legacy_storesk_host: string;
    legacy_storesk_url: string;
    legacy_storesk_status: string;
}

export const getStorePublicUrl = async (
    storeId: string
): Promise<StorePublicUrlResponse> => {
    const response = await axiosInstanceWebsite.get(`/store/public-url/storeId/${storeId}`);
    return response.data;
};
